import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, CardGroup, Col, Form, Row, Modal } from 'react-bootstrap';
import Spinner from '../../shared/spinner';
import { format, parse, parseISO, set } from 'date-fns';
import { PropostaObservacao } from '../../shared/model/propostaObservacao';
import { PropostaEsteira } from '../../shared/model/propostaEsteira';
import { ProcessoEsteiraDTO } from '../../shared/dto/processoEsteiraDTO';
import { PropostaDTO } from '../../shared/dto/propostaDTO';
import { AcaoPropostaEnum } from '../../shared/constantes/acaoPropostaEnum';
import { TipoDocumento } from '../../shared/constantes/tipoDocumento';
import { ArquivoDTO } from '../../shared/dto/arquivoDTO';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faUser, faPrint, faEye } from '@fortawesome/free-solid-svg-icons';
import { getLabelSituacaoEsteiraEnum } from '../../shared/constantes/situacaoEsteiraEnum';
import ReprovarOuPendenciarPropostaModal from '../../shared/reprovarOuPendenciarPropostaModal';
import PropostaService from '../../services/propostaService';
import PropostaDocumentoService from '../../services/propostaDocumentoService';
import EsteiraService from '../../services/esteiraService';
import PropostaEsteiraService from '../../services/propostaEsteiraService';
import PropostaObservacaoService from '../../services/propostaObservacaoService';
import CustomAlert from '../../shared/customAlert';
import { getLabelTipoProp } from '../../shared/constantes/tiposProposta';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { PropostaRefin } from '../../shared/model/propostaRefin';
import ParametrosService from '../../services/parametrosService';
import { id } from 'date-fns/locale';
import MenuService from "../../services/menuService";
import BigDataService from '../../services/bigDataService';
import { CalculoResultadoSimulacaoDTO } from '../../shared/dto/calculoResultadoSimulacaoDTO';
import { BiDollar } from 'react-icons/bi';
import { Financiamento } from '../../shared/model/financiamento';
import FinanciamentoService from '../../services/financiamentoService';
import { ResultadoSimulacaoPropostaDTO } from '../../shared/dto/resultadoSimulacaoPropostaDTO';
import { Role } from '../../shared/model/role';
import UsuarioService from '../../services/usuarioService';
import { TiposContaBanco } from '../../shared/constantes/tiposContaBanco';
import { Link } from 'react-router-dom';
import { ProtectedActionInterno } from '../../AccessControl';
import { PropostaCompraDivida } from '../../shared/model/propostaCompraDivida';
import BancoService from '../../services/bancoService';
import ComprovanteAverbacaoService from '../../services/comprovanteAverbacaoService';
import { Banco } from '../../shared/model/banco';

function GestaoDocComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  const [temPermissaoDossie, setTemPermissaoDossie] = useState(false); //Dossiê
  const [acoesAlcada, setAcoesAlcada] = useState({
    aprova: false,
    reprova: false,
    pendencia: false,
    altera: false
  });

  const navigate = useNavigate();
  const location = useLocation();
  const { idProposta, esteira, processoEsteira } = location.state || {};

  const [numeroProposta, setNumeroProposta] = useState('');

  const [backoffice, setBackoffice] = useState<string>('');

  const [showHistoricoModal, setShowHistoricoModal] = useState(false);
  const [historicoPropostas, setHistoricoPropostas] = useState<any[]>([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);

  const [loading, setLoading] = useState(false);
  const [propostaObservacao, setPropostaObservacao] = useState<PropostaObservacao[]>([]);
  const [propostaEsteira, setPropostaEsteira] = useState<PropostaEsteira[]>([]);
  const [propostaRefin, setPropostaRefin] = useState<PropostaRefin[]>([]);
  const [propostaCompraDivida, setPropostaCompraDivida] = useState<PropostaCompraDivida[]>([]);
  const [proposta, setProposta] = useState<PropostaDTO>();
  const [checkObsBanco, setCheckObsBanco] = useState(false);
  const [obs, setObs] = useState('');
  const [processoEsteiraDTO, setProcessoEsteiraDTO] = useState<ProcessoEsteiraDTO>();
  const tipoDocumento = TipoDocumento;
  const [tipoDocumentoSelecionado, setTipoDocumentoSelecionado] = useState(0);
  const [arquivo, setArquivo] = useState<File | null>(null);
  const [arquivoBase64, setArquivoBase64] = useState<string>('');
  const [nomeArquivo, setNomeArquivo] = useState<string>('');
  const [arquivosDTO, setArquivosDTO] = useState<ArquivoDTO[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [currentAction, setCurrentAction] = useState<AcaoPropostaEnum | null>(null);
  const [tipoPendenciaRecusa, setTipoPendenciaRecusa] = useState<string>('R');
  const [dossieData, setDossieData] = useState<any>(null);
  const [valoresSimulacao, setValoresSimulacao] = useState<CalculoResultadoSimulacaoDTO>();
  const [valorParcela, setValorParcela] = useState('0');
  const [prazos, setPrazos] = useState([]);
  const [prazo, setPrazo] = useState('');
  const [tpProduto, setTpProduto] = useState('');
  const [idFinanciamentoEscolhido, setIdFinanciamentoEscolhido] = useState('');
  const [tabelaFinanciamentos, setTabelaFinanciamentos] = useState<Financiamento>();
  const [showResultadoSimulacao, setShowResultadoSimulacao] = useState(false);
  const [resultadoSimulacaoFinal, setResultadoSimulacaoFinal] = useState<ResultadoSimulacaoPropostaDTO>();
  const [dtPrimeiroVencimento, setDtPrimeiroVencimento] = useState('');
  const [dtUltimoVencimento, setDtUltimoVencimento] = useState('');
  const [isUsuarioInterno, setIsUsuarioInterno] = useState(false);
  const [role, setRole] = useState<Role | null>(null);
  const [valorRMC, setValorRMC] = useState<string>('');
  const [tipoConta, setTipoConta] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [dv, setDv] = useState('');
  const [shouldScroll, setShouldScroll] = useState(false);
  const [bancos, setBancos] = useState<Banco[]>([]);

  const propostaService: PropostaService = new PropostaService();
  const propostaDocumentoService: PropostaDocumentoService = new PropostaDocumentoService();
  const propostaEsteiraService: PropostaEsteiraService = new PropostaEsteiraService();
  const esteiraService: EsteiraService = new EsteiraService();
  const propostaObservacaoService: PropostaObservacaoService = new PropostaObservacaoService();
  const menuService = new MenuService();
  const bigDataService = new BigDataService();
  const financiamentoService: FinanciamentoService = new FinanciamentoService();
  const usuarioService = new UsuarioService();
  const bancoService: BancoService = new BancoService();
  const [comprovantesData, setComprovantesData] = useState<any>(null);

  const tiposConta = TiposContaBanco;

  const handleExibirHistorico = async () => {
    setShowHistoricoModal(true);

    // Verifica se existe um CPF para consultar
    if (!proposta?.cpfCliente) return;

    setLoadingHistorico(true);
    try {
      const response = await propostaService.listarPropostasAnterioresPorCpf(proposta.cpfCliente, proposta.id);
      setHistoricoPropostas(response.data);
    } catch (err: any) {
      console.error("Erro ao buscar histórico:", err);
      setAlert({ message: 'Erro ao buscar o histórico de propostas do cliente.', type: 'error' });
    } finally {
      setLoadingHistorico(false);
    }
  };

  const verificarPermissaoDossie = async () => {
    try {
      const rotaDossie = '/bigData/consultar';
      const response = await menuService.verificaPermissaoPaginaPorRole(rotaDossie);
      setTemPermissaoDossie(response.data);
    } catch (error) {
      console.error("Erro ao verificar permissão do Dossiê:", error);
      setTemPermissaoDossie(false);
    }
  };

  const listarTodosBancos = async () => {
    try {
      setLoading(true);
      const responseList = await bancoService.listarTodosBancos();
      setBancos(responseList.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const carregarAcoesAlcada = async () => {
    try {
      const response = await propostaEsteiraService.permissoesAcoesAlcada();
      setAcoesAlcada(response.data);
    } catch (error) {
      console.error("Erro ao carregar permissões de alçada:", error);
    }
  };

  const fetchDossieData = async () => {
    try {
      const response = await bigDataService.consultarDossie(idProposta);
      setDossieData(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados do Dossiê:", error);
      setDossieData(null);
    }
  };
  const parametrosService: ParametrosService = new ParametrosService();

  const listarUsuarioPorId = async () => {
    setLoading(true);
    try {
      const id = localStorage.getItem("id") ?? "";
      const response = await usuarioService.listarUsuarioComOrigemPorId(id);
      const json = response.data[0].usuario;

      setRole(json.role);

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
      console.error(err);
    }
  };


  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = (motivoSelect: string) => {
    if (currentAction) {
      acaoProposta(currentAction, motivoSelect);
    }
    setShowModal(false);
  };

  const listarTodosParametrosTi = async () => {
    const responseList = await parametrosService.listarTodosParametros();
    const json = responseList.data;

    console.log(json)
    console.log(json.backoffice)


    setBackoffice(json.backoffice)
    console.log(backoffice)
  }

  const normalize = (str: any) => {
    if (!str) return "";
    return String(str).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();
  };

  const ultimaAtividadeRegistrada = propostaEsteira.length > 0
    ? propostaEsteira[propostaEsteira.length - 1].atividade
    : '';

  console.log("ultimaAtividadeRegistrada: ", ultimaAtividadeRegistrada)

  const isInterno = role?.tipoAcesso === 'INTERNO';

  const atividadeLimpa = normalize(ultimaAtividadeRegistrada);

  console.log("atividadeLimpa: ", atividadeLimpa)

  const isFaseAnexar = atividadeLimpa.includes('ANEX') && atividadeLimpa.includes('DOCUMENT');

  const podeAcaoRestrita = isInterno;

  console.log("isFaseAnexar: ", isFaseAnexar)

  console.log("isInterno: ", isInterno)

  console.log("acao restrita: ", podeAcaoRestrita)



  useEffect(() => {
    listarUsuarioPorId();
    const run = async () => {
      const numero = await listarEsteiraProcesso();
      await listarDocumentosProposta(numero);
      await carregarAcoesAlcada();
      await listarTodosBancos();
    };
    run();
    verificarPermissaoDossie();
  }, []);



  const listarEsteiraProcesso = async () => {
    setLoading(true);
    try {
      console.log("processoEsteira: ", processoEsteira);
      const response = await esteiraService.listarEsteiraProcessoPorIdProposta(idProposta);
      const jsonResponse = response.data;
      console.log(response.data)
      setProcessoEsteiraDTO(jsonResponse);
      setProposta(jsonResponse.propostaDTO);
      setPropostaEsteira(jsonResponse.esteiraDTO.propostaEsteiraList);
      setPropostaObservacao(jsonResponse.esteiraDTO.propostaObservacaoList);
      setPropostaRefin(jsonResponse.propostaRefinList);
      setPropostaCompraDivida(jsonResponse.propostaCompraDividaList);
      console.log(jsonResponse.propostaDTO.numeroProposta)
      setLoading(false);
      setTpProduto(jsonResponse.propostaDTO.tpProduto!);
      return jsonResponse.propostaDTO.numeroProposta
    } catch (err: any) {
      if (err.response?.status === 409) {
        console.error("Conflito: Proposta já em análise. Redirecionando para /sem-permissao", err.response.data);

        navigate('/sem-permissao', { state: { message: err.response.data } });

      } else {
        console.error("Erro ao carregar cliente:", err);
        setAlert({ message: err.response?.data || 'Erro ao carregar dados do cliente.', type: 'error' });
        setLoading(false);
      }
    }
  };

  const handleClickObs = async () => {
    setLoading(true);
    let propostaObs = new PropostaObservacao();
    propostaObs.obsBanco = checkObsBanco;
    propostaObs.observacao = obs;
    propostaObs.proposta = Number(idProposta);

    try {
      const response = await propostaObservacaoService.inclusaoPropostaObservacao(propostaObs);
      const jsonResponse = response.data;

      setPropostaObservacao([...propostaObservacao, jsonResponse]);
      setObs('');
      setCheckObsBanco(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Erro ao salvar observação:", err);
      setAlert({ message: 'Erro ao salvar comentário.', type: 'error' });
    }
  }

  const acaoProposta = async (acaoPropostaEnum: AcaoPropostaEnum, idMotivo: string | null) => {
    setLoading(true);
    try {
      const response = await propostaEsteiraService.incluirPropostaEsteiraComExecucao(idProposta, AcaoPropostaEnum.APROVAR, "VALID_SERASA", null);
      // const response = await propostaEsteiraService.incluirPropostaEsteira(idProposta, acaoPropostaEnum, idMotivo);
      const jsonResponse = response.data;

      setLoading(false);
      setAlert({ message: 'Ação ' + acaoPropostaEnum + ' realizada com sucesso!', type: 'success' });

      await sleep(2000);

      window.history.back()
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: 'Ação ' + acaoPropostaEnum + '! Erro ao realizar a ação.\n' + err.response.data, type: 'error' });
      console.error(err);
    }
  }

  const handleGerarRelatorioBigData = async (
    idProposta: number,
    tipoPdf: number,
    idBureau: number
  ) => {
    setLoading(true);
    try {
      const response = await bigDataService.geraRelatorioPdf(idProposta.toString(),
        tipoPdf, idBureau);

      // Cria um blob com o PDF recebido
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Abre o PDF em uma nova aba
      window.open(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Erro ao gerar relatório:", error);
      setAlert({
        message: 'Erro ao gerar relatório de comparação de dados',
        type: 'error'
      });
    }
  };

  const handleClickUpload = (event: any) => {
    setArquivo(event.target.files[0]);
    const reader = new FileReader();
    reader.onload = (e) => {
      if (typeof e.target?.result === 'string') {
        setArquivoBase64(e.target.result);
      }
    };
    reader.readAsDataURL(event.target.files[0]);
    setNomeArquivo(event.target.files[0].name);
  }

  const { REACT_APP_PERFIL } = process.env;

  const uploadArquivo = async () => {
    if (tipoDocumentoSelecionado === 0) {
      setAlert({ message: 'Selecione o tipo de documento!', type: 'warning' });
    } else {
      if (arquivo) {
        setLoading(true);
        try {
          let arquivoDTO = new ArquivoDTO();
          arquivoDTO.arquivoBase64 = arquivoBase64.split(',')[1];
          arquivoDTO.idProposta = Number(idProposta);
          arquivoDTO.nomeArquivo = nomeArquivo;

          if (REACT_APP_PERFIL == 'QISTA') {
            arquivoDTO.caminhoArquivo = "azure://" + nomeArquivo
          }
          arquivoDTO.tipoDocumento = tipoDocumentoSelecionado;

          await propostaDocumentoService.inclusaoPropostaDocumento(arquivoDTO)
            .then((resp) => {
              setArquivosDTO([...arquivosDTO, resp.data]);
              setTipoDocumentoSelecionado(0);
              setNomeArquivo('')
              setLoading(false);
              setAlert({ message: 'Arquivo incluído com sucesso!', type: 'success' });
            });
        } catch (err) {
          console.error(err);
          setLoading(false);
        }
      }
    }
  }

  const listarDocumentosProposta = async (numero: string) => {
    setLoading(true);
    try {

      const responseList = await parametrosService.listarTodosParametros();
      const json = responseList.data;
      setBackoffice(json.backoffice);
      let idAux = idProposta;
      if (json.backoffice === 'FUNCAO' && numero != null && numero.length > 0) {
        idAux = numero;
      }
      const response = await propostaDocumentoService.listarPropostaDocumentoPorIdProposta(idAux);
      setArquivosDTO(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const downloadArquivo = async (caminhoArquivo: string, nomeArquivo: string) => {
    setLoading(true);
    try {
      const resp = await propostaDocumentoService.downloadPropostaDocumentoPorCaminhoArquivo(caminhoArquivo);

      if (!resp || !resp.data) {
        throw new Error('Arquivo não encontrado.');
      }

      const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
      const urlBlob = window.URL.createObjectURL(blob);
      const linkDownload = document.createElement('a');
      linkDownload.href = urlBlob;
      linkDownload.download = nomeArquivo;
      document.body.appendChild(linkDownload);
      linkDownload.click();
      document.body.removeChild(linkDownload);
      window.URL.revokeObjectURL(urlBlob);
    } catch (err: any) {
      console.error(err);
      if (err.response?.status === 404 && caminhoArquivo.startsWith('s3://'))
        setAlert({ message: 'Documento não encontrado no S3!', type: 'error' });
      else
        setAlert({ message: err.response?.data || 'Erro ao baixar o arquivo!', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


  const alterarValida = async (caminhoArquivo: string, index: number) => {
    setLoading(true);
    try {
      const resp = await propostaDocumentoService.alterarValida(caminhoArquivo);

      if (resp.status === 404) {
        throw new Error('Arquivo nao encontrado.');

      }

      arquivosDTO[index].valida = !arquivosDTO[index].valida;
      setArquivosDTO([...arquivosDTO]);

    } catch (err: any) {
      console.error(err);
      if (err.response?.status === 404 && caminhoArquivo.startsWith('s3://'))
        setAlert({ message: 'Documento não encontrado no S3!', type: 'error' });
      else
        setAlert({ message: err.response?.data || 'Erro ao alterar o arquivo!', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


  const downloadTodosArquivos = async () => {
    setLoading(true);
    try {
      await propostaDocumentoService.downloadLotePropostaDocumentoPorIdProposta(idProposta)
        .then((resp) => {
          const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
          const urlBlob = window.URL.createObjectURL(blob);
          const linkDownload = document.createElement('a');
          linkDownload.href = urlBlob;
          linkDownload.download = "Proposta_" + idProposta + '.zip';
          document.body.appendChild(linkDownload);
          linkDownload.click();
          document.body.removeChild(linkDownload);
          window.URL.revokeObjectURL(urlBlob);
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  // Dispara a busca do histórico automaticamente quando a proposta (e o CPF) terminarem de carregar
  useEffect(() => {
    if (proposta?.cpfCliente) {
      handleExibirHistorico();
    }
  }, [proposta?.cpfCliente]);

  const excluirArquivo = async (caminhoArquivo: string, index: number) => {
    setLoading(true);
    try {
      await propostaDocumentoService.excluirPropostaDocumentoPorCaminhoArquivo(caminhoArquivo)
        .then(() => {
          const newTabelaIdade = [...arquivosDTO];
          newTabelaIdade.splice(index, 1);
          setArquivosDTO(newTabelaIdade);
        });
      setLoading(false);
      setAlert({ message: 'Arquivo excluído com sucesso!', type: 'success' });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  // useEffect(() => {
  //   listarEsteiraProcesso();
  //   listarDocumentosProposta();
  // }, []);

  useEffect(() => {
    const run = async () => {
      try {
        const respDossie = await menuService.verificaPermissaoPaginaPorRole('/bigData/consultar');
        setIsUsuarioInterno(respDossie.data === true);
      } catch (e) {
        setIsUsuarioInterno(false);
      }

      const numero = await listarEsteiraProcesso();
      await listarDocumentosProposta(numero);
      await carregarAcoesAlcada();
    };

    run();
    verificarPermissaoDossie();
  }, []);

  useEffect(() => {
    if (temPermissaoDossie) {
      fetchDossieData();
    }
  }, [temPermissaoDossie, idProposta]);

  const carregouFinanciamento = useRef(false);

  type PropostaModo =
    | 'VISUALIZAR_PROP'
    | 'ANALISE_RMC'
    | 'ANEXAR_DOCS'
    | 'RES_PEND';

  const modo: PropostaModo = (() => {
    switch (processoEsteira) {
      case 'ANALISE_RMC':
        return 'ANALISE_RMC';
      case 'ANEXAR_DOCS':
        return 'ANEXAR_DOCS';
      case 'RES_PEND':
        return 'RES_PEND';
      case 'VISUALIZAR_PROP':
        return 'VISUALIZAR_PROP';
      default:
        return 'VISUALIZAR_PROP';
    }
  })();

  const simulacaoEnabled =
    modo === 'ANALISE_RMC' || modo === 'RES_PEND';

  const isEmprestimo =
    tpProduto === 'EMPRESTIMO' ||
    tpProduto === 'ANTECIPACAO_REMUNERACAO';

  useEffect(() => {
    if (!proposta?.codigoTabela || carregouFinanciamento.current) return;

    carregouFinanciamento.current = true;
    listarFinanciamentoDTOPorId(proposta.codigoTabela.trim());
  }, [proposta?.codigoTabela]);


  const extrairCodigo = (valor?: string) => {
    if (!valor) return undefined;
    return valor.split('-')[0].trim();
  };

  const limparCodigoTabela = (codigo?: string) => {
    if (!codigo) return undefined;
    return codigo.replace(/\s/g, '');
  };

  const formatarValorMonetario = (valor: any) => {
    if (!valor) return '0,00';
    const valorComCentavos = valor.padStart(3, '0');
    const reais = valorComCentavos.slice(0, -2);
    const centavos = valorComCentavos.slice(-2);
    return `${parseInt(reais, 10)},${centavos}`;
  };

  const handleValorParcela = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorParcela(valorFormatado);
  };

  const handleValorRMC = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorRMC(valorFormatado);
  };

  const listarFinanciamentoDTOPorId = async (codigoTabela: string) => {
    setLoading(true);
    try {
      const response = await financiamentoService.listarPorId(codigoTabela);
      const jsonFinanciamento = response.data;
      setTabelaFinanciamentos(jsonFinanciamento);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const simulacaoRMCTotal = async (codigoFinanciamento: string, isScroll: boolean) => {
    try {
      setLoading(true);
      let calculoResultadoSimulacaoDTO: CalculoResultadoSimulacaoDTO = new CalculoResultadoSimulacaoDTO();
      const valormc = (valorRMC && valorRMC.length > 0)
        ? parseFloat(valorRMC.replace(',', '.'))
        : parseFloat(proposta?.valorRMCUtilizado?.toString() || "0");

      calculoResultadoSimulacaoDTO.valoresRMCRefin = null;
      calculoResultadoSimulacaoDTO.promotora = extrairCodigo(proposta?.promotora)!;
      calculoResultadoSimulacaoDTO.empregador = extrairCodigo(proposta?.empregador)!;
      calculoResultadoSimulacaoDTO.financiamento = limparCodigoTabela(codigoFinanciamento)!;
      calculoResultadoSimulacaoDTO.produto = extrairCodigo(proposta?.produto)!;
      calculoResultadoSimulacaoDTO.valorRMC = valormc;
      calculoResultadoSimulacaoDTO.valorLimite = 0;
      calculoResultadoSimulacaoDTO.limiteCompra = 0;
      calculoResultadoSimulacaoDTO.limiteSaque = 0;
      calculoResultadoSimulacaoDTO.tarifaEmissao = 0;
      calculoResultadoSimulacaoDTO.anuidade = 0;
      calculoResultadoSimulacaoDTO.dtNascimentoCliente = new Date(`${proposta!.dtNascimentoCliente}T00:00:00.000Z`);

      console.log(calculoResultadoSimulacaoDTO);
      await propostaService.simulacaoRMCTotal(calculoResultadoSimulacaoDTO)
        .then(resp => {
          const jsonList = resp.data;

          setValoresSimulacao(jsonList);
          const parc = proposta?.valorParcela!.toFixed(2).replace('.', ',');
          handleValorParcela(parc!);
          setPrazos(jsonList.prazos);
          setPrazo(jsonList.prazos[0]);
          setLoading(false);

          if (isScroll) {
            setShouldScroll(true);
          }

        })
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
    }
  }

  const resultadoSimulacaoParcela = async (e: any) => {
    if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && !isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    } else if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.valorRMC.toFixed(2)!) && isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    }
    let simulacaoPropostaDTO: ResultadoSimulacaoPropostaDTO = new ResultadoSimulacaoPropostaDTO();
    simulacaoPropostaDTO.promotora = extrairCodigo(proposta?.promotora)!;
    simulacaoPropostaDTO.pontoVenda = extrairCodigo(proposta?.pontoVenda)!;
    simulacaoPropostaDTO.empregador = extrairCodigo(proposta?.empregador)!;
    simulacaoPropostaDTO.financiamento = idFinanciamentoEscolhido;
    simulacaoPropostaDTO.produto = extrairCodigo(proposta?.produto)!;
    simulacaoPropostaDTO.tipoProposta = extrairCodigo(proposta?.tipoProposta)!;
    simulacaoPropostaDTO.valorRMC = proposta?.valorRMCUtilizado!;
    simulacaoPropostaDTO.valorParcela = parseFloat(valorParcela.replace(',', '.'));
    simulacaoPropostaDTO.valorSolicitado = 0;
    simulacaoPropostaDTO.prazo = parseInt(prazo);

    simulacaoPropostaDTO.limiteSaque = valoresSimulacao?.limiteSaque!;

    simulacaoPropostaDTO.cpfCliente = proposta?.cpfCliente!;
    simulacaoPropostaDTO.nomeCliente = proposta?.nomeCliente!;
    simulacaoPropostaDTO.matriculaCliente = proposta?.matriculaCliente!;
    simulacaoPropostaDTO.dtNascimentoCliente = proposta?.dtNascimentoCliente!;
    simulacaoPropostaDTO.orgao = extrairCodigo(proposta?.orgao)!;
    simulacaoPropostaDTO.valorIof = 0;
    simulacaoPropostaDTO.valorPrincipal = 0;
    simulacaoPropostaDTO.valorRefin = 0;
    simulacaoPropostaDTO.valorCompra = 0;
    simulacaoPropostaDTO.valorLiquido = 0;
    simulacaoPropostaDTO.valorBruto = 0;
    simulacaoPropostaDTO.taxaClAM = 0;
    simulacaoPropostaDTO.taxaClAA = 0;
    simulacaoPropostaDTO.taxaCetAM = 0;
    simulacaoPropostaDTO.taxaCetAA = 0;
    simulacaoPropostaDTO.primeiroVencimento = new Date();
    simulacaoPropostaDTO.ultimoVencimento = new Date();

    try {
      setLoading(true);
      console.log(simulacaoPropostaDTO);
      await propostaService.resultadoSimulacaoParcela(simulacaoPropostaDTO)
        .then(resp => {
          const jsonList = resp.data;
          console.log(resp.data)

          setResultadoSimulacaoFinal(jsonList);
          setDtPrimeiroVencimento(format(parseISO(jsonList.primeiroVencimento), 'dd/MM/yyyy'));
          setDtUltimoVencimento(format(parseISO(jsonList.ultimoVencimento), 'dd/MM/yyyy'));
          setShowResultadoSimulacao(true);
          setLoading(false);
          setShouldScroll(true);
        })
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
      setShowResultadoSimulacao(false);

    }
  }

  const atualizarProposta = async () => {
    try {
      setLoading(true);

      if (!resultadoSimulacaoFinal || !proposta) {
        setAlert({ message: 'Simulação inválida', type: 'error' });
        return;
      }

      const propostaAtualizada: PropostaDTO = {
        ...proposta,

        promotora: extrairCodigo(proposta?.promotora)!,
        pontoVenda: extrairCodigo(proposta?.pontoVenda)!,
        produto: extrairCodigo(proposta?.produto)!,
        tipoProposta: extrairCodigo(proposta?.tipoProposta)!,
        empregador: extrairCodigo(proposta?.empregador)!,
        orgao: extrairCodigo(proposta?.orgao)!,

        valorRMCUtilizado: valoresSimulacao?.valorRMC!,
        valorLimite: valoresSimulacao?.valorLimite!,
        limiteCompra: valoresSimulacao?.limiteCompra!,
        limiteSaque: valoresSimulacao?.limiteSaque!,
        tarifaEmissao: valoresSimulacao?.tarifaEmissao!,
        anuidade: valoresSimulacao?.anuidade!,
        simulacaoProposta: resultadoSimulacaoFinal!
      };

      await propostaService.atualizarProposta(propostaAtualizada);

      setAlert({
        message: 'Proposta atualizada com sucesso',
        type: 'success'
      });

    } catch (err: any) {
      console.error(err);
      setAlert({
        message: err?.response?.data || 'Erro ao atualizar proposta',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const atualizarDadosBancarios = async () => {
    try {
      setLoading(true);

      if (!proposta) {
        setAlert({ message: 'Proposta inválida', type: 'error' });
        return;
      }

      const dadosBancariosAtualizados: PropostaDTO = {
        ...proposta,

        banco: banco!,
        agencia: agencia!,
        conta: conta!,
        contaDv: dv!,
        tipoConta: tipoConta!
      };

      await propostaService.atualizarDadosBancarios(dadosBancariosAtualizados);

      setAlert({
        message: 'Dados bancários atualizados com sucesso',
        type: 'success'
      });

    } catch (err: any) {
      console.error(err);
      setAlert({
        message: err?.response?.data || 'Erro ao atualizar dados bancários',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const simulacaoRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        {esteira === 'S' ? <h5>Esteira &gt; Proposta  - {idProposta} &gt; Processos</h5> : <h5>Esteira &gt; Proposta  - {idProposta} &gt; Detalhes</h5>}
        <Button id="App-button-cor-principal" onClick={() => window.history.back()}> Voltar</Button>
      </div>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : (
        <>
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Origem</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Promotora</span>
                    <input type="text" value={proposta?.promotora!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Supervisor</span>
                    <input type="text" value={proposta?.gerente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Operador</span>
                    <input type="text" value={proposta?.operador!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Ponto de Venda</span>
                    <input type="text" value={proposta?.pontoVenda!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Empregador</span>
                    <input type="text" value={proposta?.empregador!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Secretaria/UPAG</span>
                    <input type="text" value={proposta?.orgao!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Cliente</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>CPF Cliente</span>
                    <input type="text" value={proposta?.cpfCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Nome</span>
                    <input type="text" value={proposta?.nomeCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Matricula</span>
                    <input type="text" value={proposta?.matriculaCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Data de Nascimento</span>
                    <input type="text"
                      value={proposta?.dtNascimentoCliente ? format(parseISO(proposta?.dtNascimentoCliente.toString()), 'dd/MM/yyyy') : ''}
                      className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>$ Informações Adicionais</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="info">
                    <label>Nº do Contrato:</label>
                    <span> {proposta?.numeroContrato}</span>
                  </div>
                  {/* <div className="info">
                    <label>Nº do Cartão:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>Nº Formalização:</label>
                    <span> {proposta?.idFormalizacao}</span>
                  </div>
                  {/* <div className="info">
                    <label>ID Externo Proposta:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>Nº Contrato Consignado:</label>
                    <span> {proposta?.numeroContratoExterno}</span>
                  </div>
                  <div className="info">
                    <label>ADE:</label>
                    <span> {proposta?.adeAverbacao}</span>
                  </div>
                  {/* <div className="info">
                    <label>URL CCB Não Assinada:</label>
                    <span></span>
                  </div>
                  <div className="info">
                    <label>URL CCB Assinada:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>ID Tabela:</label>
                    <span> {proposta?.codigoTabela}</span>
                  </div>
                  <div className="info">
                    <label>Código Esteira:</label>
                    <span> {proposta?.idEsteira}</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Documentos</strong>
            </div>
            <div className="card-body">
              <div className="row">
                {!proposta?.isFinalizada && (
                  <>
                    <div className="col-md-3">
                      <div className="form-group">
                        <span>Tipo de Documento</span>
                        <span style={{ textAlign: 'left' }}></span>
                        <select
                          className="form-select"
                          onChange={(e) => setTipoDocumentoSelecionado(parseInt(e.target.value))}
                        >
                          <option value="0">Selecione uma opção</option>
                          {tipoDocumento.map((item) => (
                            <option key={item.label} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <span>Arquivo</span>
                        <br />
                        <input id="App-header-table"
                          style={{ color: 'White', width: '90%' }}
                          type="file" className="form-control-file btn btn-info"
                          onChange={(e) => handleClickUpload(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group" style={{ marginTop: '25px' }}>
                        <a className="btn btn-success">
                          <i className="fa fa-upload"
                            onClick={() => uploadArquivo()}> Importar Arquivo</i>
                        </a>
                      </div>
                    </div>
                  </>
                )}
                {arquivosDTO.length > 0 ? (
                  <div style={{ marginTop: '10px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                    <div>
                      <table cellSpacing="2" cellPadding="4" rules="all" style={{ color: 'Black', backgroundColor: '#CCCCCC', borderColor: '#999999', borderWidth: '3px', borderStyle: 'Solid', width: '100%' }}>
                        <tbody>
                          <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                            <th scope="col" id="App-header-table-esquerda">Nome</th>
                            <th scope="col" id="App-header-table-esquerda">Tipo</th>
                            <th scope="col" id="App-header-table-esquerda">Data e Hora</th>
                            <th scope="col" id="App-header-table-esquerda">Valida Documentoscopia?</th>
                            <th scope="col" id="App-header-table-esquerda">Bloqueado?</th>
                            <th align="left" scope="col" id="App-header-table-esquerda">
                              <a onClick={() => downloadTodosArquivos()}>
                                <Button style={{ background: 'black', borderColor: 'black' }}>
                                  <FontAwesomeIcon icon={faDownload} />
                                </Button>
                              </a>
                            </th>
                            <th scope="col" id="App-header-table-esquerda">&nbsp;</th></tr>
                          {arquivosDTO.map((item, index) => (
                            <tr className="GridRowStyle">
                              <td>{item.nomeArquivo}</td>
                              <td>{TipoDocumento.find(tipo => tipo.value === item.tipoDocumento.toString())?.label}</td>
                              <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</td>
                              <td>
                              <input
                                type="checkbox"
                                checked={item.valida}
                                disabled={item.bloqueado}
                                onChange={() => alterarValida(item.caminhoArquivo, index)}
                              />
                              </td>
                              <td>{item.bloqueado? 'Sim' : 'Não'}</td>
                              <td align="left">
                                <a onClick={() => downloadArquivo(item.caminhoArquivo, item.nomeArquivo)}>
                                  <Button>
                                    <FontAwesomeIcon icon={faDownload} />
                                  </Button>
                                </a>
                              </td>
                              {isInterno && !proposta?.isFinalizada && (
                                <td align="left">
                                  <a onClick={() => excluirArquivo(item.caminhoArquivo, index)}>
                                    <Button style={{ background: 'red', borderColor: 'red' }}>
                                      <FontAwesomeIcon icon={faClose} />
                                    </Button>
                                  </a>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (false)}
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Observações</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Observação</span>
                    <div
                      className="form-control form-control-sm brds"
                      style={{
                        color: 'Black',
                        backgroundColor: 'LightGrey',
                        height: '120px',
                        textAlign: 'left',
                        overflowY: 'auto',
                        padding: '5px'
                      }}
                    >
                      {propostaObservacao
                        .filter(item => !isUsuarioInterno ? !item.obsBanco : true)
                        .map((item, index) => (
                          <div key={index}>
                            <span>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</span>
                            <span> - {item.usuario} - </span>
                            <span> {item.observacao} </span>
                            {item.obsBanco && (
                              <span style={{ color: 'red', fontSize: '10px', fontWeight: 'bold', marginLeft: '5px' }}>
                                [INTERNO]
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              {!proposta?.isFinalizada && (
                <>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-md-12">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Nova Observação</span>
                        <textarea
                          className="form-control"
                          style={{ height: '80px', textAlign: 'left', width: '100%' }}
                          value={obs}
                          onChange={(e) => setObs(e.target.value)}
                        />
                        {isUsuarioInterno && (
                          <div style={{ marginTop: '5px' }}>
                            <input
                              type="checkbox"
                              checked={checkObsBanco}
                              onChange={() => setCheckObsBanco(!checkObsBanco)}
                            />
                            <label style={{ marginLeft: '5px' }}>Observação interna do Banco</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <a className="btn btn-success" onClick={handleClickObs}>
                        <i className="fa fa-save"> Gravar Observação</i>
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {temPermissaoDossie && dossieData && (
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-header">
                <strong>Dossiê - Análise de Dados Cadastrais</strong>
              </div>
              <div className="card-body">
                <div style={{ width: '100%', borderWidth: '1px' }}>
                  <table
                    cellSpacing="2"
                    cellPadding="4"
                    rules="all"
                    style={{
                      border: '3',
                      color: 'Black',
                      borderColor: '#999999',
                      borderWidth: '3px',
                      borderStyle: 'Solid',
                      width: '100%',
                    }}
                  >
                    <thead>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">ID</th>
                        <th scope="col" id="App-header-table-esquerda">ID Proposta</th>
                        <th scope="col" id="App-header-table-esquerda">Tipo de Dossiê</th>
                        <th scope="col" id="App-header-table-esquerda">Criado em</th>
                        <th scope="col" id="App-header-table-esquerda">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(Array.isArray(dossieData) ? dossieData : [dossieData])
                        .filter((item: any) => item.tipoDossieDescricao === 'Serasa')
                        .map((item: any) => (
                          <tr className="GridRowStyle" key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.idProposta}</td>
                            <td style={{ fontWeight: 'bold' }}>{item.tipoDossieDescricao}</td>
                            <td>{new Date(item.createdAt).toLocaleString()}</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() =>
                                  handleGerarRelatorioBigData(item.idProposta, item.tipoPdf, item.id)
                                }
                              >
                                Ver
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Ações</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {esteira === 'S' && propostaEsteira[propostaEsteira.length - 1] !== undefined && propostaEsteira[propostaEsteira.length - 1].acao !== AcaoPropostaEnum.FINALIZADA ? (
                      <>
                        {acoesAlcada.aprova && (
                          <a
                            className="btn btn-success">
                            <i className="fa fa-thumbs-up"
                              onClick={() => acaoProposta(AcaoPropostaEnum.APROVAR, null)}>
                              Aprovar
                            </i>
                          </a>
                        )}
                        {acoesAlcada.pendencia && propostaEsteira.length > 2 && propostaEsteira[propostaEsteira.length - 2].acao !== AcaoPropostaEnum.PENDENCIAR && podeAcaoRestrita && (
                          <a
                            className="btn btn-secondary"
                            style={{ backgroundColor: 'YELLOW', color: 'BLACK' }}
                            onClick={() => {
                              setCurrentAction(AcaoPropostaEnum.PENDENCIAR);
                              setTipoPendenciaRecusa("P");
                              setShowModal(true);
                            }}
                          >
                            Pendenciar
                          </a>
                        )}

                        <ReprovarOuPendenciarPropostaModal
                          showModal={showModal}
                          handleModalCancel={handleModalCancel}
                          handleModalConfirm={handleModalConfirm}
                          tipoPendenciaRecusa={tipoPendenciaRecusa}
                        />
                      </>
                    ) : false}
                    <a
                      id="App-button-cor-principal"
                      className="btn btn-secondary"
                      onClick={() => window.history.back()}
                    >
                      <i className="fa fa-backward"> Voltar</i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

    </div >
  );
}

export default GestaoDocComponent;
